import React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


// Class a table gives (through setFilterChipProps) to the chip of a filter it drives from elsewhere, e.g. a status toggle
export const HIDDEN_FILTER_CHIP = 'app-filter-chip-hidden'

const columnName = column => column?.name ?? column

// Head of the filter panel with how many filters are on. The table renders it as the panel's footer
// (customFilterDialogFooter, the only slot that gets the live filter list) and the theme moves it to the top.
export default function AppTableFilterHeader({ filterList = [], columns = [], setFilterChipProps }) {
	const active = filterList.filter((values, idx) => {
		if (!values?.length) return false
		const chipProps = setFilterChipProps?.(idx, columnName(columns[idx]), values)
		return !chipProps?.className?.includes(HIDDEN_FILTER_CHIP)
	}).length

	return <Box className="app-filter-header" sx={{
		order: -1, display: 'flex', alignItems: 'center', gap: 1.25,
		pl: 2.25, pr: 18, py: 1.75, borderBottom: `1px solid ${dsColorNew.grayBorder}`,
	}}>
		<Box sx={{
			width: 32, height: 32, borderRadius: '9px', flexShrink: 0,
			display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
			background: `linear-gradient(135deg, ${dsColorNew.webBlue500}, ${dsColorNew.cyan})`, color: dsColorNew.white,
		}}>
			<IconSeeker icon="filter" sx={{ fontSize: 13 }}/>
		</Box>
		<Box sx={{ minWidth: 0 }}>
			<Typography sx={{ fontSize: 15, fontWeight: 600, color: dsColorNew.textTitle, lineHeight: 1.3 }}>Filters</Typography>
			<Typography sx={{ fontSize: 12, color: dsColorNew.textMuted }}>Only the rows that match all of them</Typography>
		</Box>
		{active > 0 && <Box component="span" sx={{
			fontSize: 11, fontWeight: 600, color: dsColorNew.appBlue, backgroundColor: dsColorNew.pillActiveBg,
			borderRadius: '10px', px: 1, py: 0.25, whiteSpace: 'nowrap',
		}}>
			{active} on
		</Box>}
	</Box>
}
